import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GenericState } from "src/helpers/createGenericSlice";
import { CommonPagination } from "../../../types/api/common";
import { Mention } from "../../../types/api/ticket";

type MentionState = GenericState<CommonPagination<Mention> | null> & {
    details: Mention | null;
};

const initialState: MentionState = {
    data: null,
    status: "finished",
    details: null,
};

const mentionsSlice = createSlice({
    name: "ticket/mention",
    initialState,
    reducers: {
        start(state, action: PayloadAction) {
            state.status = "loading";
            state.data = null;
        },
        loadMore(state, action: PayloadAction<{ page: number }>) {
            state.status = "loading";
        },
        success(state, action: PayloadAction<CommonPagination<Mention>>) {
            state.status = "finished";
            state.data = action.payload;
        },
        update(state, action: PayloadAction<{ id: number; seen: boolean }>) {},
        loadMoreSuccess(
            state,
            action: PayloadAction<CommonPagination<Mention>>
        ) {
            state.status = "finished";
            state.data = {
                ...state.data,
                ...action.payload,
                data: [...(state.data?.data || []), ...action.payload.data],
            };
        },
        updateMention(state, action: PayloadAction<Mention>) {
            if (state.data) {
                const index = state.data.data.findIndex(
                    (i) => i.id === action.payload.id
                );

                if (index) {
                    state.data.data.splice(index, 1, action.payload);
                }
            }
        },
        setMentionDetails(state, action: PayloadAction<Mention | null>) {
            state.details = action.payload;
        },
        setMentions(
            state,
            action: PayloadAction<{
                data: CommonPagination<Mention> | null;
                status: "loading" | "finished";
            }>
        ) {
            const { data, status } = action.payload;
            state.data = data;
            state.status = status;
        },
    },
});

export const {
    start,
    success,
    update,
    loadMore,
    loadMoreSuccess,
    updateMention,
    setMentionDetails,
    setMentions,
} = mentionsSlice.actions;

export default mentionsSlice.reducer;
